export const getPasswordStrengthScore = (password: string): number => {
  const value = String(password || '')
  if (!value) return 0

  let score = 0
  if (value.length >= 8) score += 1
  if (value.length >= 12) score += 1
  if (/[a-z]/.test(value) && /[A-Z]/.test(value)) score += 1
  if (/\d/.test(value)) score += 1
  if (/[^A-Za-z0-9]/.test(value)) score += 1

  return Math.min(4, score)
}

export const isPasswordStrongEnough = (password: string): boolean =>
  getPasswordStrengthScore(password) >= 2
